import { connected } from 'process';
import { JsonLoader } from './JsonLoader';
import { UtilFunc } from './UtilFunc';
export interface rankObj {
    rank: number,
    name?: string,
    score: number
}

export interface ResRanks {
    code: number,
    message: string,
    data: {
        ranks: rankObj[]
    }
}

export interface sendScore {
    code: number,
    message: string,
    data: rankObj
}


export class GameApi {
    
    private game_id: number;
    private uuid: string;
    private host: string;
    private HOST_LOCAL: string = "http://localhost:8100/game/"

    public sendScore;

    constructor(game_id: number, uuid: string) {
        this.game_id = game_id;
        this.uuid = uuid;
        const env = UtilFunc.getEnv();
        // console.log(env);

        this.host = this.HOST_LOCAL;
    }

    /**
     * ランキング取得
     * @param  game_id ゲームID
     */
    async getInitApi(): Promise<ResRanks> {
        const jsonLoader = new JsonLoader();
        jsonLoader.setMethod('GET');
        jsonLoader.setURL(this.host + 'init.php');
        const result = await jsonLoader.load();
        console.log(result);
        return <ResRanks>result;
    }

    /**
     * ランキング取得
     * @param  game_id ゲームID
     */
    async PostResultApi(): Promise<ResRanks> {
        const jsonLoader = new JsonLoader();
        jsonLoader.setMethod('GET');
        jsonLoader.setURL(this.host + 'result.php');
        const result = await jsonLoader.load();
        console.log(result);
        return <ResRanks>result;
    }

}